var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"jumbotron"},[_c('h1',{staticClass:"jumbotron__title"},[_vm._t("title")],2),_vm._v(" "),(_vm.hasSubtitle)?_c('div',{staticClass:"jumbotron__subtitle"},[_vm._t("subtitle")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }